<template>
    <div ref="mqlFilter" class="mql-filter" :class="{border:border}">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'MqlFilter',
    components: {
    },
    props: {
        border: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
        }
    },
    mounted () {

    },
    methods: {
    }
}
</script>

<style lang='scss' scoped>
.mql-filter {
    position: relative;
    padding: 10px;
    margin-bottom: 20px;
    &.border {
        border: 1px solid #eee;
    }
    .el-input {
        .el-input__inner {
            height: 26px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlFilter/index.vue